import axiosInstance from "./axios-service/axiosInstance";

const requisitionSkillSetsService = {
  fetchAllRequisitionSkillSets: () => {
    return axiosInstance.get(
      "/itl_skillsets?$select=itl_experience,_itl_requisitionid_value,itl_skillname,_itl_skillset_value&$expand=itl_SkillSet($select=itl_skillsetmasterid,itl_name)&$orderby=createdon desc"
    );
  },

  fetchRequisitionSkillSet: (id) => {
    return axiosInstance.get(
      `/itl_skillsets?$select=itl_skillsetid,itl_experience,itl_experiencerange,_itl_requisitionid_value,itl_skillname,_itl_skillset_value&$expand=itl_SkillSet($select=itl_skillsetmasterid,itl_name)&$filter=_itl_requisitionid_value eq ${id}&$orderby=createdon asc`
    );
  },

  requisitionSkillSetsService: (obj) => {
    return axiosInstance.post("/itl_skillsets", obj);
  },

  updateRequisitionSkillSet: (id, obj) => {
    return axiosInstance.patch(`/itl_skillsets(${id})`, obj);
  },

  deleteRequisitionSkillSet: (id) => {
    return axiosInstance.delete(`/itl_skillsets(${id})`);
  },
};

export default requisitionSkillSetsService;
